<template>
  <div
    class="favorite-form"
    data-toggle="tooltip"
    data-placement="top"
    title="加入喜愛產品"
  >
    <button
      :class="favoriteButtonClass"
      @click="changeFavorite"
    ></button>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    favoriteAdded: {
      type: Boolean,
      defalut: false,
    },
    favoriteAddedData: {
      type: Boolean,
      defalut: false,
    },
  },
  computed: {
    favoriteButtonClass() {
      return {
        btn: true,
        favoriteBtn: true,
        added: this.favoriteAddedData,
      };
    },
  },
  created() {
    this.$emit('change-favorite-added-data', this.favoriteAdded);
  },
  methods: {
    async changeFavorite() {
      let response;
      try {
        response = await axios.post(`product/favorite/${this.id}`);
      } catch (error) {
        console.warn(error);
      }

      const { data } = response;

      if (data.status === 'not login') {
        window.location.href = 'user/login';

        global.Message.show('請先登入會員');

        return false;
      }

      if (data.favoriteAdded) {
        global.Message.show('已經加入喜愛產品');
      } else {
        global.Message.show('已經從喜愛產品中移除');
      }

      this.$emit('change-favorite-added-data', data.favoriteAdded);
    },
  },
};
</script>
<style scoped lang="scss">
.favorite-form {
  display: flex;
  margin-left: 1rem;
  height: 25px;
  button {
      flex: 0 0 25px;
      background-size: contain;
      cursor: pointer;
      background: url(../img/pic/love.svg) no-repeat;
      transition: 0.3s;
    &.added, &:hover {
        background: url(../img/pic/love_green.svg) no-repeat;
    }
  }
}

</style>
